export const innerStructure = [
  {
    isVisible: true,
    isBold: false,
    title: "Secondary1",
    image: "",
    position: 1,
    variations: [
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary1",
        position: 1,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary2",
        position: 2,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary3",
        position: 3,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary4",
        position: 4,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary5",
        position: 5,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary6",
        position: 6,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary7",
        position: 7,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary8",
        position: 8,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary9",
        position: 9,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary10",
        image: "",
        position: 10,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary11",
        image: "",
        position: 11,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary12",
        image: "",
        position: 12,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary13",
        image: "",
        position: 13,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary14",
        image: "",
        position: 14,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary15",
        image: "",
        position: 15,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary16",
        image: "",
        position: 16,
        link: "#",
      },
    ],
    spotItems: [
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Header",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem1",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem2",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem3",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Link",

        link: "#",
      },
    ],
  },
  {
    isVisible: true,
    isBold: false,
    title: "Secondary2",
    image: "",
    position: 2,
    variations: [
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary1",
        position: 1,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary2",
        position: 2,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary3",
        position: 3,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary4",
        position: 4,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary5",
        position: 5,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary6",
        position: 6,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary7",
        position: 7,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary8",
        position: 8,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary9",
        position: 9,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary10",
        image: "",
        position: 10,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary11",
        image: "",
        position: 11,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary12",
        image: "",
        position: 12,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary13",
        image: "",
        position: 13,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary14",
        image: "",
        position: 14,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary15",
        image: "",
        position: 15,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary16",
        image: "",
        position: 16,
        link: "#",
      },
    ],
    spotItems: [
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Header",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem1",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem2",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem3",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Link",

        link: "#",
      },
    ],
  },
  {
    isVisible: true,
    isBold: false,
    title: "Secondary3",
    image: "",
    position: 3,
    variations: [
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary1",
        position: 1,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary2",
        position: 2,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary3",
        position: 3,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary4",
        position: 4,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary5",
        position: 5,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary6",
        position: 6,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary7",
        position: 7,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary8",
        position: 8,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary9",
        position: 9,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary10",
        image: "",
        position: 10,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary11",
        image: "",
        position: 11,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary12",
        image: "",
        position: 12,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary13",
        image: "",
        position: 13,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary14",
        image: "",
        position: 14,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary15",
        image: "",
        position: 15,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary16",
        image: "",
        position: 16,
        link: "#",
      },
    ],
    spotItems: [
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Header",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem1",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem2",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem3",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Link",

        link: "#",
      },
    ],
  },
  {
    isVisible: true,
    isBold: false,
    title: "Secondary4",
    image: "",
    position: 4,
    variations: [
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary1",
        position: 1,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary2",
        position: 2,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary3",
        position: 3,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary4",
        position: 4,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary5",
        position: 5,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary6",
        position: 6,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary7",
        position: 7,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary8",
        position: 8,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary9",
        position: 9,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary10",
        image: "",
        position: 10,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary11",
        image: "",
        position: 11,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary12",
        image: "",
        position: 12,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary13",
        image: "",
        position: 13,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary14",
        image: "",
        position: 14,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary15",
        image: "",
        position: 15,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary16",
        image: "",
        position: 16,
        link: "#",
      },
    ],
    spotItems: [
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Header",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem1",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem2",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem3",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Link",

        link: "#",
      },
    ],
  },
  {
    isVisible: true,
    isBold: false,
    title: "Secondary5",
    image: "",
    position: 5,
    variations: [
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary1",
        position: 1,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary2",
        position: 2,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary3",
        position: 3,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary4",
        position: 4,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary5",
        position: 5,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary6",
        position: 6,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary7",
        position: 7,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary8",
        position: 8,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary9",
        position: 9,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary10",
        image: "",
        position: 10,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary11",
        image: "",
        position: 11,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary12",
        image: "",
        position: 12,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary13",
        image: "",
        position: 13,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary14",
        image: "",
        position: 14,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary15",
        image: "",
        position: 15,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary16",
        image: "",
        position: 16,
        link: "#",
      },
    ],
    spotItems: [
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Header",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem1",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem2",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem3",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Link",

        link: "#",
      },
    ],
  },
  {
    isVisible: true,
    isBold: false,
    title: "Secondary6",
    image: "",
    position: 6,
    variations: [
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary1",
        position: 1,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary2",
        position: 2,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary3",
        position: 3,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary4",
        position: 4,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary5",
        position: 5,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary6",
        position: 6,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary7",
        position: 7,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary8",
        position: 8,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary9",
        position: 9,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary10",
        image: "",
        position: 10,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary11",
        image: "",
        position: 11,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary12",
        image: "",
        position: 12,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary13",
        image: "",
        position: 13,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary14",
        image: "",
        position: 14,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary15",
        image: "",
        position: 15,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary16",
        image: "",
        position: 16,
        link: "#",
      },
    ],
    spotItems: [
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Header",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem1",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem2",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem3",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Link",

        link: "#",
      },
    ],
  },
  {
    isVisible: true,
    isBold: false,
    title: "Secondary7",
    image: "",
    position: 7,
    variations: [
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary1",
        position: 1,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary2",
        position: 2,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary3",
        position: 3,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary4",
        position: 4,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary5",
        position: 5,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary6",
        position: 6,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary7",
        position: 7,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary8",
        position: 8,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary9",
        position: 9,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary10",
        image: "",
        position: 10,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary11",
        image: "",
        position: 11,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary12",
        image: "",
        position: 12,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary13",
        image: "",
        position: 13,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary14",
        image: "",
        position: 14,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary15",
        image: "",
        position: 15,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary16",
        image: "",
        position: 16,
        link: "#",
      },
    ],
    spotItems: [
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Header",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem1",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem2",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem3",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Link",

        link: "#",
      },
    ],
  },
  {
    isVisible: true,
    isBold: false,
    title: "Secondary8",
    image: "",
    position: 8,
    variations: [
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary1",
        position: 1,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary2",
        position: 2,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary3",
        position: 3,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary4",
        position: 4,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary5",
        position: 5,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary6",
        position: 6,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary7",
        position: 7,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary8",
        position: 8,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary9",
        position: 9,
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary10",
        image: "",
        position: 10,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary11",
        image: "",
        position: 11,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary12",
        image: "",
        position: 12,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary13",
        image: "",
        position: 13,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary14",
        image: "",
        position: 14,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary15",
        image: "",
        position: 15,
        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Teritiary16",
        image: "",
        position: 16,
        link: "#",
      },
    ],
    spotItems: [
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Header",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem1",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem2",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "SpotItem3",
        body: "Body",
        image: "",

        link: "#",
      },
      {
        isVisible: true,
        isBold: false,
        title: "Spotlight Link",

        link: "#",
      },
    ],
  },
];
